import type { WeekdayNumbers } from "luxon";

export const REPORT_MAIN_CATEGORY_IDS = {
    PRP: "prp",
    SALES_SUMMARIES: "sales-summaries",
} as const;

export type ReportMainCategoryId = (typeof REPORT_MAIN_CATEGORY_IDS)[keyof typeof REPORT_MAIN_CATEGORY_IDS];

export const SALES_SUMMARY_PERIOD_IDS = {
    DAILY: "daily",
    WEEKLY: "weekly",
    MONTHLY: "monthly",
} as const;

export const SALES_SUMMARY_PERIOD_ORDER = [
    SALES_SUMMARY_PERIOD_IDS.DAILY,
    SALES_SUMMARY_PERIOD_IDS.WEEKLY,
    SALES_SUMMARY_PERIOD_IDS.MONTHLY,
] as const;

export type SalesSummaryPeriodId = (typeof SALES_SUMMARY_PERIOD_IDS)[keyof typeof SALES_SUMMARY_PERIOD_IDS];

export const REPORT_VIEW_IDS = {
    FIRST_HALF: "first_half",
    SECOND_HALF: "second_half",
    DAILY: "daily",
    WEEKLY: "weekly",
} as const;

export type ReportViewId = (typeof REPORT_VIEW_IDS)[keyof typeof REPORT_VIEW_IDS];

export type ReportPillVariant = "good" | "warn";

export type ReportItemTone = "green" | "orange";

export type ReportPill = {
    text?: string;
    variant: ReportPillVariant;
};

export type ReportItem = {
    text?: string;
    tone: ReportItemTone;
};

export type ReportFocus = {
    labelKey: string;
    label?: string;
    text?: string;
};

export type ReportSummary = {
    score: number;
    titleKey: string;
    title?: string;
    subtitleKey: string;
    subtitle?: string;
    subtitleCount?: number;
    pills: ReportPill[];
};

export type ReportSections = {
    strengthsTitleKey: string;
    weaknessesTitleKey: string;
    focusTitleKey: string;
    focus: ReportFocus;
    conclusionTitleKey: string;
    conclusion?: string;
    strengths: ReportItem[];
    weaknesses: ReportItem[];
};

export type HalfCompareCard = {
    labelKey: string;
    label?: string;
    score: number;
    callsCount: number;
    timeRangeKey: string;
    timeRange?: string;
    accent?: "default" | "positive";
};

export type WeekDayReport = {
    weekdayIndex: WeekdayNumbers;
    score: number | null;
    callsCount: number | null;
    isToday?: boolean;
    isPending?: boolean;
};

export type WeeklyComparison = {
    previousWeekAverage: number;
    currentWeekAverage: number;
    trendText?: string;
    trendDirection: "up" | "down" | "stable";
};
